const cloudApi = {
  ACCOUNT_INFO: '/org/account/info', //获取用户信息
  GET_USER_LOGO_API: '/org/tenant/info' //获取租户logo信息
};

export { cloudApi };
